import type { FC } from 'react';

import { useQuickReloadSubscriber } from './useQuickReloadSubscriber.ts';
import type { QuickReloaderType } from './QuickReloadContext.tsx';

export const QuickReloadSubscriber: FC<QuickReloaderType> = (reloaderProps) => {
	useQuickReloadSubscriber(reloaderProps);
	return null;
};
